import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "/sign_in/google",
  class: "AuthButton",
  style: {"text-decoration":"underline"}
}, "Googleでログイン", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "/sign_in/ms",
  class: "AuthButton",
  style: {"text-decoration":"underline"}
}, "Microsoftでログイン", -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  href: "/sign_in/google",
  class: "AuthButton"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  href: "/sign_in/ms",
  class: "AuthButton"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "fl mt6" }, "Sign in with SSO", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isSP)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createTextVNode("    "),
          _hoisted_4
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("a", _hoisted_6, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/buttons/google_bnr.png`),
              width: "200",
              height: "46"
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("a", _hoisted_8, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/buttons/microsoft_bnr.png`),
              width: "200",
              height: "46"
            }, null, 8, _hoisted_9)
          ]),
          _hoisted_10,
          (_ctx.showSSO)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "pointer pad7 rad4 mt5 hoverGreyBg mc",
                style: {"height":"44px","width":"200px","border":"1px solid #333"},
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickSSO && _ctx.clickSSO(...args)))
              }, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/key.png`),
                  class: "fl mt3 mr20 ml5",
                  width: "24",
                  height: "24"
                }, null, 8, _hoisted_11),
                _hoisted_12
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}